module.exports = __webpack_public_path__ + "img/company.95a3789f.svg";